import { Addon } from '@/domain/entities/addon.entity';
import { apiClient } from '@/data/api/axios-client';
import { AddonResponseDTO } from '../dto/addon.dto';

interface GetAddonsOptions {
    module?: string;
    useMock?: boolean;
}

/**
 * Repository for addon data.
 * Supports both real API and mock data via parameter.
 */
export const addonRepository = {
    getAddons: async (options: GetAddonsOptions | boolean = {}): Promise<Addon[]> => {
        const normalizedOptions =
            typeof options === 'boolean' ? { useMock: options } : options;
        const { module, useMock = false } = normalizedOptions;

        if (useMock) {
            // Mock data for fallback or testing
            return [
                {
                    id: 'addon-extra-pax',
                    name: 'Extra Pax',
                    description: 'Additional person in the studio (above 6 years old).',
                    price: 10,
                    unit: 'pax',
                    isActive: true,
                },
                {
                    id: 'addon-fast-delivery',
                    name: 'Fast Delivery',
                    description: 'Receive all soft copies within 24 hours.',
                    price: 20,
                    isActive: true,
                },
            ];
        }

        const endpoint = process.env.NEXT_PUBLIC_ADDONS || '/api/addons';
        const response = await apiClient.get<AddonResponseDTO>(
            endpoint,
            module ? { params: { module } } : undefined
        );

        if (response.success && response.data) {
            return response.data.map((dto) => ({
                id: dto.id,
                name: dto.name,
                description: dto.description,
                price: dto.price,
                unit: dto.unit,
                isActive: dto.isActive,
            }));
        }

        return [];
    },
};
